'use client'

import { ReactNode } from 'react'
import { AuthProvider } from '@domain/auth/Auth.context'
import { AuthTokenManager } from '@domain/auth/AuthTokenManager.context'
import { AuthButtonBridgeProvider } from '@domain/auth/context/AuthButtonBridge.context'
import { Web3ReadyProvider } from '@domain/auth/context/Web3ReadyContext'
import { AutoWalletConnectProvider } from '@domain/auth/AutoWalletConnect.context'
import { CWDocumentsProvider } from '@components/shared/terms-and-conditions/CWDocumentsContext.tsx'
import { FavouriteProjectsProvider } from '@domain/projects/favourite-projects-context/FavouriteProjects.context'

/**
 * Layer 1 - Lightweight providers only (SSR-safe, no Privy/Wagmi/viem).
 * Renders during SSG and first paint so content and "Log in" button appear immediately.
 */
export function LightweightProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <AuthTokenManager>
        <AutoWalletConnectProvider>
          <CWDocumentsProvider>
            <FavouriteProjectsProvider>
              <AuthButtonBridgeProvider>
                <Web3ReadyProvider>{children}</Web3ReadyProvider>
              </AuthButtonBridgeProvider>
            </FavouriteProjectsProvider>
          </CWDocumentsProvider>
        </AutoWalletConnectProvider>
      </AuthTokenManager>
    </AuthProvider>
  )
}
